'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cookieAuthentication = exports.allowMissingPortalId = exports.ensurePortalId = exports.withCsrf = exports.logoutOnMissingCsrf = exports.ensureHttps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _url = require('../helpers/url');

var _params = require('../helpers/params');

var params = _interopRequireWildcard(_params);

var _core = require('./core');

var _hubapi = require('./hubapi');

var _index = require('../index');

var _cookies = require('../helpers/cookies');

var _accessTokenAuth = require('./accessTokenAuth');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this is super naive but will work for all the relevant domains
var rootDomainExpression = /^([a-zA-Z0-9\-\.]+)\.([a-zA-Z0-9\-]+)\.com$/;

var ensureHttps = exports.ensureHttps = function ensureHttps(options) {
  if (!_enviro2.default.deployed('hub-http') && options.location.protocol !== 'https:') {
    var message = 'Cookie authentication require apps to be on https';

    // eslint-disable-next-line no-console
    console.error('[hub-http]', message);

    throw new Error(message);
  }

  return options;
};

var logoutOnMissingCsrf = exports.logoutOnMissingCsrf = function logoutOnMissingCsrf(options) {
  return (0, _hubapi.logoutOn)(function () {
    return !(0, _cookies.getCookie)(options.csrfCookieName, options.cookies);
  })(options);
};

var withCsrf = exports.withCsrf = function withCsrf(options) {
  return (0, _core.header)('X-HubSpot-CSRF-hubspotapi', (0, _cookies.getCookie)(options.csrfCookieName, options.cookies))(options);
};

var ensurePortalId = exports.ensurePortalId = function ensurePortalId(options) {
  var parsed = (0, _url.parseUrl)(options.url);
  if (!params.parse(parsed.query).portalId) {
    return (0, _index.createStack)(_hubapi.logoutOnMissingPortalId, (0, _core.query)({ portalId: options.portalId }))(options);
  }

  return options;
};

var cookieAuthStack = (0, _index.createStack)(logoutOnMissingCsrf, withCsrf, function (options) {
  return options.allowMissingPortalId ? options : ensurePortalId(options);
});

var allowMissingPortalId = exports.allowMissingPortalId = function allowMissingPortalId(options) {
  return _extends({
    allowMissingPortalId: true
  }, options);
};

var cookieAuthentication = exports.cookieAuthentication = function cookieAuthentication(config) {
  return function (options) {
    var domainsConfig = config;
    var domain = (0, _url.parseUrl)(options.url).hostname;
    var configForDomain = domainsConfig.find(function (dc) {
      return dc.matcher.test(domain);
    });

    var appRootDomain = options.location.hostname.match(rootDomainExpression);
    var apiRootDomain = domain.match(rootDomainExpression);

    // compare the domain. This all only will work for naive "foo.mydomain.com" scenarios. And it's all it needs to work for right now
    var isFirstPartyDomain = appRootDomain != null && apiRootDomain != null && appRootDomain[appRootDomain.length - 1] === apiRootDomain[apiRootDomain.length - 1];

    return configForDomain && (isFirstPartyDomain || (0, _cookies.getCookie)('cookieverified', options.cookies) === '1') ? cookieAuthStack(_extends({}, options, {
      csrfCookieName: configForDomain.csrfCookieName
    })) : (0, _accessTokenAuth.accessToken)(options);
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.196/js/middlewares/cookieAuth.js
// module id = 24
// module chunks = 0